import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
import HubPopup from "./HubPopup";
import ClientPopup from "./FacilityPopup.js";
var functions = require("./functions.js");

// WarningTable component
export default class WarningTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);

        let sendWarningsToSlack=true;
        if( this.props.hostname){
            sendWarningsToSlack=false;
        }


        // initalize state
        this.state = {
            warnings:undefined,
            hostname:"",
            warning_type:"",
            send_warnings_to_slack:sendWarningsToSlack,
            hubVisible:false,
            clientVisible:false,
            warning:{hub_id:0},
            clientTabIndex:1,
            hubTabIndex:4
        }
        this.inputRef = React.createRef();
    }
    componentDidMount() {
        this.inputRef.current.focus();
    }
    inputFilterKeyUp(event) {
        this.setState({
            hostname:document.getElementById("hostname").value
            ,warning_type:document.getElementById("warning_type").value

        });
        if (event.keyCode === 13) {
          event.preventDefault();
          this.queryWarnings();
        }
    }    
    handleClick(event){
        console.log(event.target.checked)
        this.setState({
            send_warnings_to_slack : event.target.checked
        });
      };
    // render
    render() {
        if(!this.state.warnings){
            this.queryWarnings();
        }
        let cols=[];
        if(!this.props.hostname){
            cols.push({ key: 'facility_name', title:"Client", width:5 });
            cols.push({ key: 'display_name', title:"Name", width:5 });
            cols.push({ key: 'hostname', title:"hostname", width:5 });
        }
        cols.push({ key: 'warning_date', title:"Date", width:5, render:functions.renderDateInTable });
        cols.push({ key: 'warning', title:"Warning", width:60 });
        return (
            <div>
                <div>
                    Host Name:<input id="hostname" defaultValue={this.props.hostname} className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)} ref={this.inputRef}/>&nbsp;
                    Type:<input id="warning_type" className='input-filter' onKeyUp={this.inputFilterKeyUp.bind(this)}/>&nbsp;
                    Send To Slack:<input id="send_warnings_to_slack" defaultChecked className="sql-editor-clear-results-before-query" type="checkbox" onChange={this.handleClick.bind(this)}></input>
                    <button onClick={()=>{this.queryWarnings()}} >Query Warnings</button>&nbsp;
                    <a href="https://github.com/wave-dds/wave-device-tracking-app/blob/main/sql/v_hub_warnings.sql" rel="noopener noreferrer" target="_blank">Logic</a>
                </div>
                <TableScrollbar height="80vh">
                    <ErrorBoundary>
                        <Table columns={cols} 
                                dataSource={this.state.warnings}
                                onRowClick={this.editHub.bind(this)}      
                                />
                    </ErrorBoundary>
                </TableScrollbar>
                <HubPopup
                    hubId={this.state.warning.hub_id}
                    visible={this.state.hubVisible}
                    securityObject={this.props.securityObject}
                    onCloseHubPopup={this.closePopup.bind(this)}
                    tabIndex={this.state.hubTabIndex}
                >
                </HubPopup>
                <ClientPopup 
                    clientId={this.state.warning.facility_id}
                    visible={this.state.clientVisible}
                    securityObject={this.props.securityObject}
                    onCloseClientPopup={this.closePopup.bind(this)}
                    tabIndex={this.state.clientTabIndex}
                >
                </ClientPopup>                
            </div>
        );
    }

    // load the table
    queryWarnings(params){
        let hostname=this.props.hostname;
        if(!hostname){
            hostname=this.state.hostname
        }
        db.getWarnings( 
            hostname
            ,this.state.warning_type
            ,this.state.send_warnings_to_slack
            ,this.props.securityObject
            ,(warningList) => { 
                this.setState({
                    warnings : warningList
                })
            }
            ,params
        )
    }
   
    // close the hub popup
    closePopup(){
        this.queryWarnings();
        this.setState({
            hubVisible:false,
            clientVisible:false
        })
    }
    // edit a hub
    editHub( rowData, rowIndex ){
        if (rowData.hub_id){
            
            if(!this.props.hostname){
                let hubTabIndex=4;
                if(rowData.warning_type==="warning"){hubTabIndex=0}
                this.setState({
                    warning:rowData
                    , hubVisible:true
                    ,hubTabIndex:hubTabIndex
                })
            } 
        }else {
            this.setState({
                warning:rowData
                , clientVisible:true
            })
        }
    }

    renderWarning(cellData, rowData, rowIndex){
        return React.createElement('textarea',{ className: 'warningNote' },cellData );
    }
}